import React from 'react';

import Modal from 'components/Modal';

export default ({ title, content, buttons, onClose }) => (
  <Modal
    id="MyClocksModal"
    title={title}
    contentAbove={content}
    buttons={buttons}
    onClose={onClose}
  />
);
